//@flow
import {type AuthNamespaceState, type HasTokensState} from '$src/auth/types'
import {type Payload} from '$util/setTokensState'

export const login = (
  {tokensState: oldTokensState}: {tokensState: HasTokensState | {hasTokens: false}},
  payload: Payload
): AuthNamespaceState => {

  const newTokensState: HasTokensState = {
    hasTokens: true,
    uid: payload.uid,
    email: payload.email,
    idToken: payload.id_token,
    refreshToken: payload.refresh_token,
  }

  const newAuthState = {
    tokensState: newTokensState,
  }
  localStorage.setItem('frank-auth', JSON.stringify(newAuthState))
  return newAuthState
}

export const logout = (): AuthNamespaceState => {
  const newAuthState = {
    tokensState: {hasTokens: false},
  }
  localStorage.setItem('frank-auth', JSON.stringify(newAuthState))
  return newAuthState
}



// WEBPACK FOOTER //
// ./src/auth/reducers.js